import deepMerge from "./deep-merge";
/**
 * Return an object that only contains properties that are different or added from sources
 * compared to the target. Will not actually update the target.
 *
 * @param {object} target The target object
 * @param {object} sources The source(s)
 * @returns {object} The copied opject
 */
export default function deepDiff(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    return deepMerge(target, sources, { changedOnly: true, noAssign: true });
}
//# sourceMappingURL=deep-diff.js.map